import { createAsyncThunk } from '@reduxjs/toolkit';
import { SilentThunkError } from '@socialive/common';
import normalizeAvailableTrayWorkflow from '../../../normalizers/availableTrayWorkflow';
import client from '../../../services/api-client';
import selectApiBaseUrl from '../../env/selectors/selectApiBaseUrl';
import { selectTrayAccountId } from '../selectors';

export default createAsyncThunk('connectionManager/fetchTrayAvailableWorkflows', async (payload, { getState }) => {
  const { accountId } = payload;
  const apiBaseUrl = selectApiBaseUrl(getState());

  const url = `${apiBaseUrl}/workflows/get-solutions/${accountId}`;

  const response = await client(url);
  const rawWorkflows = response?.data?.viewer?.solutions?.edges;

  // Only pick the solutions with a isReady
  const workflows = rawWorkflows.map(normalizeAvailableTrayWorkflow).filter(({ isReady }) => Boolean(isReady));

  if (accountId !== selectTrayAccountId(getState())) {
    throw new SilentThunkError('trayAccountId changed during processing');
  }

  return workflows;
});
